import { z } from 'zod';

import { playerSchema } from '../roster';
import { baseEventSchema } from './base-event';

export type SprintEvent = z.output<typeof sprintEventSchema>;
export type SprintEventDTO = z.input<typeof sprintEventSchema>;

export const sprintEventSchema = baseEventSchema.extend({
  maxSpeed: z.number(),
  type: z.literal('sprint'),
});

export type SprintEventWithPlayer = z.output<typeof sprintEventWithPlayerSchema>;
export type SprintEventWithPlayerDTO = z.input<typeof sprintEventWithPlayerSchema>;

export const sprintEventWithPlayerSchema = sprintEventSchema.extend({
  player: playerSchema,
});
